import React, { useEffect } from 'react';
import '../styles/Theatre.css';
import Footer from '../components/Footer';

const Theatre = () => {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll) - equivalent functionality
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observe all elements with data-aos attribute
    const animatedElements = document.querySelectorAll('[data-aos]');
    animatedElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="theatre-page">
      {/* Hero Section with Theatre Background */}
      <div className="hero-section">
        {/* Background Image */}
        <div 
          className="hero-background"
          style={{
            backgroundImage: "url('/assets/img/theatrebg.png')"
          }}
        ></div>
        
        {/* Overlay */}
        <div className="hero-overlay"></div>
        
        {/* Hero Content */}
        <div className="hero-content">
          <div className="container">
            <div className="row align-items-center min-vh-100">
              <div className="col-12 text-center">
                <h1 className="hero-title" data-aos="fade-up" data-aos-duration="1000">
                  Cinema Advertising
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cinema Channels Section */}
      <section className="tv-channels-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="channels-title" data-aos="fade-up" data-aos-duration="1000">
                Cinema Advertisement Channels
              </h2>
              <div className="channels-description" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                <p className="description-text">
                  ARK Advertising offers dynamic cinema advertising solutions through top multiplex and single-screen channels like PVR Cinemas, INOX, Cinepolis, Carnival Cinemas, and leading regional theaters. We create high-impact audiovisual ads that play before movie screenings, ensuring maximum attention from captive audiences. With precise targeting by location, language, and movie genre, ARK helps brands reach urban and rural viewers alike. From blockbuster releases to local events, cinema ads offer unmatched visibility and engagement—perfect for brand awareness and promotions.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            <div className="col-lg-4 col-md-4 col-sm-6 col-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="800">
              <div className="channel-card">
                <div className="channel-logo">
                  <img src="/assets/theaters/pvrlogo.png" alt="PVR" className="img-fluid" />
                </div>
                <h3 className="channel-name">PVR</h3>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-6" data-aos="fade-up" data-aos-delay="200" data-aos-duration="800">
              <div className="channel-card">
                <div className="channel-logo">
                  <img src="/assets/theaters/inox logo.png" alt="INOX" className="img-fluid" />
                </div>
                <h3 className="channel-name">Inox</h3>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-6" data-aos="fade-up" data-aos-delay="300" data-aos-duration="800">
              <div className="channel-card">
                <div className="channel-logo">
                  <img src="/assets/theaters/ROHINIlogo.png" alt="Rohini Cinemas" className="img-fluid" />
                </div>
                <h3 className="channel-name">Rohini Cinemas</h3>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-6" data-aos="fade-up" data-aos-delay="400" data-aos-duration="800">
              <div className="channel-card">
                <div className="channel-logo">
                  <img src="/assets/theaters/jazzlogo.png" alt="Jazz Cinemas" className="img-fluid" />
                </div>
                <h3 className="channel-name">Jazz Cinemas</h3>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-6" data-aos="fade-up" data-aos-delay="500" data-aos-duration="800">
              <div className="channel-card">
                <div className="channel-logo">
                  <img src="/assets/theaters/spilogo.png" alt="SPI Cinemas" className="img-fluid" />
                </div>
                <h3 className="channel-name">Spi Cinemas</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Works in Cinema Advertisement Section */}
      <section className="tv-works-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="works-title" data-aos="fade-up" data-aos-duration="1000">
                Our Works in Cinema Advertisement
              </h2>
              <div className="title-underline" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000"></div>
            </div>
          </div>
          
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6" data-aos="fade-right" data-aos-duration="1000">
              <div className="works-image-container">
                <img src="/assets/theaters/pvrlogo.png" alt="PVR Cinema" className="works-image" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
              <div className="works-content">
                <h3 className="works-subtitle">PVR ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising provides premium cinema advertising solutions in partnership with PVR Cinemas, India's leading multiplex chain. With access to high footfall locations and a captive, diverse audience, PVR ads offer exceptional brand visibility across metro cities and tier-2 towns. Whether it's on-screen commercials, foyer branding, standees, seat backs, or digital screens, ARK crafts visually striking and engaging ad experiences. Perfect for product launches, brand campaigns, and regional promotions, PVR advertising ensures your message reaches an attentive and high-value audience.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
          </div>
          
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6" data-aos="fade-right" data-aos-duration="1000">
              <div className="works-content">
                <h3 className="works-subtitle">INOX CINEMAS ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising offers powerful and engaging ad solutions through INOX Cinemas, one of India's top multiplex chains. With a premium movie-watching environment and a diverse, attentive audience, INOX provides the perfect platform for on-screen commercials, digital displays, standees, and experiential foyer branding. ARK ensures creative, location-specific campaigns that boost brand recall and connect with target viewers across urban and semi-urban areas. Whether it's for product promotions or brand awareness, INOX advertising with ARK delivers maximum impact and visibility.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
              <div className="works-image-container">
                <img src="/assets/theaters/inox logo.png" alt="INOX Cinema" className="works-image" />
              </div>
            </div>
          </div>

          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6" data-aos="fade-right" data-aos-duration="1000">
              <div className="works-image-container">
                <img src="/assets/theaters/ROHINIlogo.png" alt="Rohini Cinemas" className="works-image" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
              <div className="works-content">
                <h3 className="works-subtitle">Rohini Cinemas ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising offers targeted and impactful cinema advertising at Rohini Cinemas, one of Chennai's most iconic and high-traffic theaters. With a loyal and diverse audience base, especially for Tamil blockbuster releases, Rohini Cinemas provides an ideal platform for local and regional brand promotions. ARK enables strategic ad placements—on-screen commercials, standees, posters, and digital lobby displays—ensuring your message reaches audiences with high attention and engagement. Perfect for brands aiming to connect with the Tamil-speaking market through a trusted entertainment hub.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
          </div>
          
          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6" data-aos="fade-right" data-aos-duration="1000">
              <div className="works-content">
                <h3 className="works-subtitle">Jazz Cinemas ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising offers premium cinema advertising opportunities at Jazz Cinemas, known for its state-of-the-art screens and strong presence in Chennai and Tamil Nadu. With a stylish ambiance and a steady flow of moviegoers, Jazz Cinemas is an excellent venue to showcase your brand through high-quality on-screen ads, foyer activations, standees, and digital signage. ARK ensures that your campaigns are creatively tailored and strategically placed to capture maximum audience attention—ideal for regional promotions, product launches, and brand awareness in a high-engagement environment.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
              <div className="works-image-container">
                <img src="/assets/theaters/jazzlogo.png" alt="Jazz Cinemas" className="works-image" />
              </div>
            </div>
          </div>

          <div className="row align-items-center mt-5">
            <div className="col-lg-6 col-md-6" data-aos="fade-right" data-aos-duration="1000">
              <div className="works-image-container">
                <img src="/assets/theaters/spilogo.png" alt="SPI Cinemas" className="works-image" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
              <div className="works-content">
                <h3 className="works-subtitle">Spi Cinemas ADVERTISING</h3>
                <p className="works-description">
                  ARK Advertising delivers premium and creative advertising solutions through SPI Cinemas, a top-tier cinema chain known for its high-end screens like Sathyam, Escape, Palazzo, and others across South India. With a sophisticated movie-going audience and a strong brand presence, SPI Cinemas offers unmatched visibility through on-screen ads, foyer branding, digital displays, standees, and interactive activations. ARK ensures each campaign is tailored for maximum impact, helping brands connect with urban, tech-savvy, and entertainment-focused viewers in a stylish and immersive setting.
                </p>
                <button className="know-more-btn">KNOW MORE</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Theatre;
